import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { DvfPropertyType, WatchlistUpdate } from '@app/shared';
import { addToWatchlist, fetchAnalysis, fetchWatchlist, updateWatchlistItem } from './api';

const watchlistKey = ['market', 'watchlist'] as const;

export function useWatchlist() {
  return useQuery({ queryKey: watchlistKey, queryFn: fetchWatchlist });
}

export function useAddToWatchlist() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: addToWatchlist,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: watchlistKey }),
  });
}

export function useUpdateWatchlistItem() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, update }: { id: number; update: WatchlistUpdate }) => updateWatchlistItem(id, update),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: watchlistKey }),
  });
}

/**
 * Analyse d'une sélection de communes. Lancée à la demande (`codes` non nul) : la première fois,
 * chaque commune télécharge plusieurs fichiers DVF, ce qui prend plusieurs secondes.
 */
export function useSectorAnalysis(codes: readonly string[] | null, propertyType: DvfPropertyType) {
  return useQuery({
    queryKey: ['market', 'analysis', propertyType, codes],
    queryFn: () => fetchAnalysis(codes!, propertyType),
    enabled: codes !== null && codes.length > 0,
    staleTime: 10 * 60 * 1000,
    retry: false,
  });
}
